/**
 * A date in a table (rule 29): « 21 hours ago » under a week, « 2026-08-02 »
 * after, and the exact date and time in the anchored tooltip (§26). The cell
 * is focusable, so the keyboard reaches the time the mouse does.
 */
import type React from 'react';
import { exactWhen, tableWhen } from '../lib/format';
import { WithTooltip } from './Tooltip';

export function DateCell({
  at,
  prefix,
  empty = '—',
  style
}: {
  at: number | string | null | undefined;
  /** A word before the date, « invited » or « seen ». */
  prefix?: string;
  /** What the cell says when there is no date. */
  empty?: string;
  style?: React.CSSProperties;
}): React.JSX.Element {
  const exact = exactWhen(at);
  if (!exact) return <span style={style}>{empty}</span>;
  return (
    <WithTooltip text={exact} style={style}>
      {prefix ? `${prefix} ${tableWhen(at)}` : tableWhen(at)}
    </WithTooltip>
  );
}
